import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessageBirdService {
  private http = inject(HttpClient);

  private generatedCode: string | null = null;
  private attempts = 0;
  private maxAttempts = 3;

  private readonly urlMessage=environment.titanUrl;

  constructor() {}

  sendOtpCodewhatsapp(phoneNumber: string): Observable<{ code: string }> {
    this.attempts = 0;
    return new Observable<{ code: string }>(observer => {
      this.http.post<string>(
        `${this.urlMessage}/Titan/SendOtp/${phoneNumber}`, 
        {}, 
        { responseType: 'text' as 'json' }
      ).subscribe({
        next: response => {
          this.generatedCode=response;
          observer.next({ code: response });
          observer.complete();
        },
        error: err => observer.error(err)
      });
    });
  }


  verifyOtpCode(userCode: string): Observable<{ success: boolean }> {
    if (this.generatedCode === null) {
      return throwError(() => new Error('No OTP fue generado.'));
    }

    if (this.attempts >= this.maxAttempts) {
      return throwError(() => new Error('NumberAttemptsPassed'));
    }

    if (userCode === this.generatedCode) {
      return new Observable(observer => {
        observer.next({ success: true });
        observer.complete();
      });
    } else {
      this.attempts++;
      if (this.attempts >= this.maxAttempts) {
        return throwError(() => new Error('NumberAttemptsPassed'));
      }
      return new Observable(observer => {
        observer.next({ success: false });
        observer.complete();
      });
    }
  }
}
